import { PostStimMethodBase } from './base/post-stim-method-base';

export class PostStimMethod extends PostStimMethodBase { }